import { render, staticRenderFns } from "./addUserRight.vue?vue&type=template&id=261cbb0c&"
import script from "./addUserRight.vue?vue&type=script&lang=js&"
export * from "./addUserRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports